import React from 'react';

import "./PDSAPlanTabOne.css";
import {NextButton} from "../../../../../../common/button/next-button/NextButton";
import {BackButton} from "../../../../../../common/button/back-button/BackButton";
import {StandardButton} from "../../../../../../common/button/standard-button/StandardButton";
import {ToolTip} from "../../../../../../common/tool-tip/ToolTip";

export const PDSAPlanTabOne = ({
                                   PDSA,
                                   setPDSA,
                                   setCurrentScreen,
                                   navigateBack,
                                   navigateTo,
                                   context,
                                   active,
                                   setSpinnerText,
                                   showToaster,
                                   toolTipsEnabled
                               }) => {

    const isButtonDisabled = () => {
        return !PDSA.who || !PDSA.what || !PDSA.where;
    }

    return (
        <div className="plan-tab-one-container">
            <div className="plan-tab-one-input-container">
                <div className="input-container">
                    <div>
                        <label>Who:</label>
                        {toolTipsEnabled &&
                        <ToolTip tooltipExternalReference={"pdsawho123"}
                                 context={context}
                                 setSpinnerText={setSpinnerText} showToaster={showToaster}
                                 fieldName={"Who:"}/>}
                    </div>
                    <input className="text-input"
                           onChange={({target}) => {
                               setPDSA((prevState) => ({
                                   ...prevState,
                                   who: target.value
                               }));
                           }}
                           defaultValue={PDSA.who ? PDSA.who : null}
                           disabled={!active || !context.editMode}
                    />
                </div>
                <div className="input-container">
                    <div>
                        <label>What:</label>
                        {toolTipsEnabled &&
                        <ToolTip tooltipExternalReference={"pdsawhat123"}
                                 context={context}
                                 setSpinnerText={setSpinnerText} showToaster={showToaster}
                                 fieldName={"What:"}/>}
                    </div>
                    <input className="text-input"
                           onChange={({target}) => {
                               setPDSA((prevState) => ({
                                   ...prevState,
                                   what: target.value
                               }));
                           }}
                           defaultValue={PDSA.what ? PDSA.what : null}
                           disabled={true}
                    />
                </div>
                <div className="input-container">
                    <div>
                        <label>Where:</label>
                        {toolTipsEnabled &&
                        <ToolTip tooltipExternalReference={"pdsawhere123"}
                                 context={context}
                                 setSpinnerText={setSpinnerText} showToaster={showToaster}
                                 fieldName={"Where:"}/>}
                    </div>
                    <input className="text-input"
                           onChange={({target}) => {
                               setPDSA((prevState) => ({
                                   ...prevState,
                                   where: target.value
                               }));
                           }}
                           defaultValue={PDSA.where ? PDSA.where : null}
                           disabled={!active || !context.editMode}
                    />
                </div>
            </div>
            <div className="back-to-overview-pdsa-button-container">
                <StandardButton text="Problem Overview" onClick={() => {
                    navigateTo("problemTree");
                }}/>
            </div>
            <div className="pdsa-navigation-button-container">
                <BackButton onClick={navigateBack}/>
                <NextButton disabled={isButtonDisabled()} onClick={() => {
                    setCurrentScreen("PDSAPlanTabTwo");
                }}/>
            </div>
        </div>
    );
}
